// Copyright (c) Move Closer 2022.

import { RouteConfig } from 'vue-router'
import { RouteConfigSingleView } from 'vue-router/types/router'

import { StaticRoute } from '@core'

import StaticView from '@module/content/views/StaticView.vue'

/**
 * Decorate routes with static definitions.
 *
 * @param routes
 * @param staticRoutes
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function decorateStaticRoutes (routes: RouteConfig[], staticRoutes: StaticRoute[]): RouteConfig[] {
  const listOfDefinedStaticNames: Record<string, string> = {}
  for (const s of staticRoutes) {
    listOfDefinedStaticNames[s.route] = s.path
  }

  for (let i = 0; i < routes.length; ++i) {
    const route: RouteConfigSingleView = routes[i]
    const isStatic: boolean = typeof route.meta === 'object' && typeof route.meta.static === 'boolean'
      ? route.meta.static : true

    if (!route.name || !isStatic) {
      continue
    }

    const viewComponent = route.component
    let registeredPath: string = route.name && (route.name in listOfDefinedStaticNames)
      ? listOfDefinedStaticNames[route.name].replace(/(\/\*|\/)$/g, '') : route.path

    registeredPath = registeredPath.startsWith('/') ? registeredPath : `/${registeredPath}`
    // Let's consider if there's any param at considered route.
    const matches = route.path.match(/:.*$/)
    if (matches && !registeredPath.includes(matches[0])) {
      registeredPath = `${registeredPath}/${matches[0]}`
    }

    route.path = registeredPath
    route.component = StaticView
    route.meta = { ...(route.meta ?? {}), viewComponent }

    routes[i] = route
  }

  return routes
}
